var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { memo } from 'react';
import styled from 'styled-components';
import { Divider as PCLNDivider } from 'pcln-design-system';
var StyledDivider = /*#__PURE__*/styled(PCLNDivider).withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-1kzr704-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 1;\n"], ["\n  z-index: 1;\n"])));
function Divider() {
  return React.createElement(StyledDivider, {
    borderColor: 'background.light',
    my: 0
  });
}
export default memo(Divider);
var templateObject_1;